import React, { useState, useEffect } from 'react';
import { adminLogin, getAdminCaptcha } from './../api/adminApi';
import { useAdminAuth } from './../context/AdminAuthContext';
export const AdminLogin = () => {
  const { login } = useAdminAuth();
  const [formData, setFormData] = useState({ account_name: '', password: '' });
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadCaptcha = async () => {
    const result = await getAdminCaptcha();
    if (result.success) {
      setCaptchaId(result.data.captchaId);
      setCaptchaSvg(result.data.svg);
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.account_name.trim() || !formData.password.trim()) {
      setError('لطفا نام کاربری و رمز عبور را وارد نمایید.');
      return;
    }

    if (!captchaAnswer.trim()) {
      setError('لطفا کد امنیتی تصویر را وارد نمایید.');
      return;
    }

    setLoading(true);
    const result = await adminLogin(formData.account_name, formData.password, captchaId, captchaAnswer);
    setLoading(false);

    if (result.success) {
      login(result.data.user, result.data.token);
    } else {
      setError(result.message);
      setCaptchaAnswer('');
      loadCaptcha(); // بعد از هر تلاش ناموفق، کپچا رو عوض کن
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#1c2529',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'rtl'
      }}
    >
      <div
        className="w3-card-4 w3-animate-zoom"
        style={{
          backgroundColor: '#263238',
          borderTopLeftRadius: '30px',
          borderBottomRightRadius: '30px',
          padding: '30px',
          width: '380px',
          maxWidth: '90%'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <div
            className="w3-circle"
            style={{
              width: 70,
              height: 70,
              backgroundColor: '#2980b9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <i className="material-icons w3-text-white" style={{ fontSize: 38 }}>
              admin_panel_settings
            </i>
          </div>
        </div>

        <h3 className="w3-text-white w3-center" style={{ marginBottom: 20 }}>
          ورود به پنل مدیریت
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="w3-section w3-text-white">
            <label>نام کاربری</label>
            <input
              type="text"
              name="account_name"
              value={formData.account_name}
              onChange={handleChange}
              className="w3-input"
              style={{
                border: '1px solid white',
                backgroundColor: 'transparent',
                borderRadius: '2px',
                borderTopLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                height: '40px',
                color: 'white'
              }}
            />
          </div>

          <div className="w3-section w3-text-white">
            <label>رمز عبور</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w3-input"
              style={{
                border: '1px solid white',
                backgroundColor: 'transparent',
                borderRadius: '2px',
                borderTopLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                height: '40px',
                color: 'white'
              }}
            />
          </div>

          {/* بخش کپچا */}
          <div className="w3-section w3-text-white">
            <label>کد امنیتی تصویر</label>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                backgroundColor: '#1c2529',
                borderRadius: 10,
                padding: 8,
                border: '1px solid #37474F'
              }}
            >
              <div
                style={{ flexShrink: 0, borderRadius: 6, overflow: 'hidden' }}
                dangerouslySetInnerHTML={{ __html: captchaSvg }}
              />
              <button
                type="button"
                onClick={loadCaptcha}
                className="w3-button"
                title="تصویر جدید"
                style={{ color: '#4FC3F7', backgroundColor: 'transparent', flexShrink: 0 }}
              >

                <i className="material-icons">refresh</i>
              </button>
            </div>

            <input
              type="text"
              value={captchaAnswer}
              onChange={(e) => setCaptchaAnswer(e.target.value)}
              placeholder="کد نشان‌داده‌شده در تصویر را وارد کنید"
              className="w3-input"
              style={{
                border: '1px solid white',
                backgroundColor: 'transparent',
                borderRadius: '2px',
                borderTopLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                height: '40px',
                color: 'white',
                marginTop: 8
              }}
            />
          </div>

          {error && (
            <p className="w3-text-red" style={{ fontSize: 13, marginTop: 8 }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w3-button w3-block w3-round-xxlarge w3-margin-top"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #2980b9',
              color: '#15ff00',
              padding: '10px'
            }}
          >
            {loading ? 'در حال ورود...' : 'ورود'}
          </button>
        </form>
      </div>
    </div>
  );
};